import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgCutlery = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="url(#cutlery_svg__a)"
        d="M28.62 30.06v30.78l-3.85.19c-1.65 0-2.98-2.05-2.98-4.59v-26.2z"
      />
      <foreignObject width={16.59} height={24.93} x={16.42} y={8}>
        <div
          style={{
            backdropFilter: "blur(1px)",
            clipPath: "url(#cutlery_svg__b)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <path
        fill="url(#cutlery_svg__d)"
        d="m21.46 13.04.07 13.26 1.7.04-.07-16.3a3.04 3.04 0 0 1 3.03 3.04l.08 13.26 1.7.04-.08-16.3a3.04 3.04 0 0 1 3.04 3.04l.08 17.81-10.81-.03c-1.68 0-1.7-1.4-1.7-3.08L18.42 10a3.04 3.04 0 0 1 3.04 3.04"
      />
      <path
        fill="url(#cutlery_svg__e)"
        d="M43.17 61.02h3.92V31.83h-7.86v24.7c0 2.48 1.76 4.5 3.94 4.5Z"
      />
      <foreignObject width={13.15} height={35.51} x={36.01} y={4.82}>
        <div
          style={{
            backdropFilter: "blur(1px)",
            clipPath: "url(#cutlery_svg__f)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <path
        fill="url(#cutlery_svg__h)"
        d="M47.15 38.33h-9.14V18.61c0-6.52 2.63-11.8 9.15-11.8z"
      />
      <path fill="#37b1fd" d="M39.24 31.84h7.86v6.5h-7.86z" opacity={0.3} />
      <path fill="#37b1fd" d="M39.24 32.65h7.86v5.68h-7.86z" opacity={0.3} />
      <path fill="#37b1fd" d="M39.24 33.46h7.86v4.87h-7.86z" opacity={0.3} />
      <path fill="#37b1fd" d="M39.24 34.28h7.86v4.05h-7.86z" opacity={0.3} />
      <path fill="#37b1fd" d="M39.24 35.1h7.86v3.23h-7.86z" opacity={0.3} />
      <defs>
        <linearGradient
          id="cutlery_svg__a"
          x1={28.62}
          x2={23.49}
          y1={59.14}
          y2={34.33}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009cfc" stopOpacity={0.8} />
          <stop offset={0.67} stopColor="#26b3fd" stopOpacity={0.6} />
          <stop offset={0.89} stopColor="#84edff" stopOpacity={0.8} />
          <stop offset={1} stopColor="#97f8ff" stopOpacity={0.8} />
        </linearGradient>
        <linearGradient
          id="cutlery_svg__d"
          x1={24.71}
          x2={24.71}
          y1={27.93}
          y2={9.11}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009cfc" stopOpacity={0.6} />
          <stop offset={0.28} stopColor="#26b3fd" stopOpacity={0.4} />
          <stop offset={0.89} stopColor="#84edff" stopOpacity={0.8} />
          <stop offset={1} stopColor="#97f8ff" stopOpacity={0.8} />
        </linearGradient>
        <linearGradient
          id="cutlery_svg__e"
          x1={47.1}
          x2={45.02}
          y1={59.75}
          y2={42.58}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009cfc" stopOpacity={0.8} />
          <stop offset={0.67} stopColor="#26b3fd" stopOpacity={0.6} />
          <stop offset={0.89} stopColor="#84edff" stopOpacity={0.8} />
          <stop offset={1} stopColor="#97f8ff" stopOpacity={0.8} />
        </linearGradient>
        <linearGradient
          id="cutlery_svg__h"
          x1={30.05}
          x2={53.34}
          y1={17.77}
          y2={21.07}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009cfc" stopOpacity={0.8} />
          <stop offset={0.33} stopColor="#26b3fd" stopOpacity={0.6} />
          <stop offset={0.76} stopColor="#84edff" stopOpacity={0.8} />
          <stop offset={1} stopColor="#97f8ff" stopOpacity={0.8} />
        </linearGradient>
        <clipPath id="cutlery_svg__b">
          <path d="m5.04 5.04.07 13.26 1.7.04-.07-16.3a3.04 3.04 0 0 1 3.03 3.04l.08 13.26 1.7.04-.08-16.3a3.04 3.04 0 0 1 3.04 3.04l.08 17.81-10.81-.03c-1.68 0-1.7-1.4-1.7-3.08L2 2a3.04 3.04 0 0 1 3.04 3.04" />
        </clipPath>
        <clipPath id="cutlery_svg__f">
          <path d="M11.15 33.51H2.01V13.79c0-6.52 2.63-11.8 9.15-11.8z" />
        </clipPath>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgCutlery);
export default Memo;
